import { render } from "preact"
import { BuildVersion } from "./BuildVersion"
import { startQuizFromIds } from "./quizState"
import { rerender } from "./render"
import { hydrateBookmarkCache, hydrateHistoryCache, hydrateReviewResultCache } from "./storage"

hydrateReviewResultCache()
hydrateBookmarkCache()
hydrateHistoryCache()

// Exposes a deterministic quiz entry for the snapshot harness, which drives a
// fixed set of questions so the quiz, feedback, and results captures stay stable
// when the question bank changes. Inert during normal use.
;(window as unknown as { startQuizFromIds: typeof startQuizFromIds }).startQuizFromIds = startQuizFromIds

const buildVersionMount = document.getElementById("buildVersion")
if (buildVersionMount) render(<BuildVersion />, buildVersionMount)

rerender()
